import { tsrContractsClient } from '../tsrContractsClient';

export const patientPrescriptionsClient = () => tsrContractsClient.patientPrescriptionContract;
